"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _mui = require("tss-react/mui");
var _material = require("@mui/material");
var _Translate = _interopRequireDefault(require("@mui/icons-material/Translate"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const useStyles = (0, _mui.makeStyles)()(theme => ({
  menu: {
    padding: 0
  },
  formControl: {
    margin: theme.spacing(1)
  },
  group: {
    margin: theme.spacing(1)
  },
  language: {
    marginTop: "auto",
    marginBottom: "auto",
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(2)
  }
}));
function SiteLanguageSelector({
  t,
  currentLanguage,
  handleChangeLanguage,
  languageOptions = [{
    value: "en",
    label: "English"
  }, {
    value: "en-US",
    label: "English US"
  }]
}) {
  const {
    classes
  } = useStyles();
  const [language, setLanguage] = (0, _react.useState)(currentLanguage);
  function handleChange(event) {
    const value = event.target.value;
    setLanguage(value);
    handleChangeLanguage(value);
    handleCloseMenu();
  }
  const [anchorEl, setAnchorEl] = (0, _react.useState)(null);
  const open = Boolean(anchorEl);
  function handleMenu(event) {
    setAnchorEl(event.currentTarget);
  }
  function handleCloseMenu() {
    setAnchorEl(null);
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Tooltip, {
      title: t("change_language"),
      enterDelay: 300,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.IconButton, {
        color: "inherit",
        "aria-label": t("change_language"),
        "aria-haspopup": "true",
        onClick: handleMenu,
        size: "large",
        "aria-expanded": Boolean(anchorEl),
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Translate.default, {})
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
      className: classes.language,
      children: language.toUpperCase()
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Menu, {
      id: "site-language-selector-menu-appbar",
      className: classes.menu,
      anchorEl: anchorEl,
      anchorOrigin: {
        vertical: "top",
        horizontal: "right"
      },
      keepMounted: true,
      transformOrigin: {
        vertical: "top",
        horizontal: "right"
      },
      open: open,
      onClose: handleCloseMenu,
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_material.FormControl, {
        component: "fieldset",
        className: classes.formControl,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_material.FormLabel, {
          component: "legend",
          children: t("language")
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.RadioGroup, {
          "aria-label": "language",
          name: "language",
          className: classes.group,
          value: language,
          onChange: handleChange,
          children: languageOptions.map(option => /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.FormControlLabel, {
            value: option.value,
            control: /*#__PURE__*/(0, _jsxRuntime.jsx)(_material.Radio, {}),
            label: option.label
          }))
        })]
      })
    })]
  });
}
SiteLanguageSelector.propTypes = {};
var _default = exports.default = SiteLanguageSelector;